/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import { Link } from 'react-router-dom';
// import { connect } from 'react-redux';
import { Header, Step, Icon } from 'semantic-ui-react';
import { EnjoyLogo/* , EnjoyIcon *//* , SupportedServices */ } from '@emyw/core-lib';
import { LogOut } from '@emyw/auth-lib';
import { withAppContext } from '../AppContext';
import { loadUser as loadUserWithDispatch } from '../actions/userActions';
import { getCurrentPromoCode } from '../utils';

// import logo from '../logo.svg';
import './SiteHeader.css';

// const { REACT_APP_TOKEN_NAME, REACT_APP_REFRESH_TOKEN_NAME } = process.env;

const loadUser = () => new Promise((resolve) => {
    loadUserWithDispatch('network-only')(({ user }) => {
        resolve(user);
    });
});

const logout = (context) => {
    // localStorage.removeItem(REACT_APP_TOKEN_NAME);
    // localStorage.removeItem(REACT_APP_REFRESH_TOKEN_NAME);
    LogOut();
    localStorage.removeItem('enjoy-promo-code');
    localStorage.removeItem('verification-email');
    localStorage.removeItem('enjoy-signup-progress');
    localStorage.removeItem('plan-code');
    sessionStorage.removeItem('user-form-values');
    sessionStorage.removeItem('social-user');
    // (loadUserWithDispatch('network-only'))(({ user }) => {
    //     context.setAppState({ user });
    // });
    // Wait for current promoCode before setting app state even though the code isn't used here
    Promise.all([loadUser(), getCurrentPromoCode()]).then(([user/* , promoCode */]) => {
        // log.trace(promoCode);
        context.setAppState({ user });
    });
};

export const SiteHeader = ({
    // user,
    context,
}) => {
    const { state } = context;
    const { user, currentStep, skipPlanSelect } = state;
    // On certain pages, show the supported providers
    const stepHeadStyle = currentStep === 'plan' ? { margin: '0' } : {};
    const signOutInLinkStyle = { /* paddingTop: '0.5em', paddingBottom: '0.5em', */ whiteSpace: 'nowrap' };
    // const websiteLink = <a href="https://www.enjoymoviesyourway.com" rel="noopener noreferrer" target="_blank">website</a>;
    return (
        <div>
            <Header className="sitebanner" style={stepHeadStyle}>
                {/* <div> */}
                <Link to="/"/* style={{ whiteSpace: 'nowrap', paddingBottom: '.5em' }} */>
                    {/* <h1><EnjoyIcon /> Enjoy</h1> */}
                    <EnjoyLogo />
                </Link>
                {user
                    ? <Link to="/signup" style={signOutInLinkStyle} onClick={() => logout(context)}>Sign Out</Link>
                    : <Link to="/login" style={signOutInLinkStyle}>Sign In</Link>
                }
                {/* </div> */}
            </Header>
            {/* {currentStep === 'plan' && (
                <Header className="enjoySupportedVendors" style={{ textAlign: 'center', marginTop: '0.5em' }}>
                    <Header as="h3" color="grey" className="lighter">
                        Supported Streaming Services
                        <Header.Subheader>See the {websiteLink} for the complete list</Header.Subheader>
                    </Header>
                    <SupportedServices />
                </Header>
            )} */}
            <div className="subscribeStepBar">
                <Step.Group unstackable/* size="mini" */>
                    {!skipPlanSelect && (
                        <Step active={currentStep === 'plan'} disabled={currentStep !== 'plan'}>
                            <Icon name="table" />
                            <Step.Content>
                                <Step.Title>Select</Step.Title>
                                <Step.Title>Plan</Step.Title>
                            </Step.Content>
                        </Step>
                    )}

                    <Step active={currentStep === 'account'} disabled={currentStep !== 'account'}>
                        <Icon name="address card" />
                        <Step.Content>
                            <Step.Title>Create</Step.Title>
                            <Step.Title>Account</Step.Title>
                        </Step.Content>
                    </Step>

                    <Step active={currentStep === 'billing'} disabled={currentStep !== 'billing'}>
                        <Icon name="payment" />
                        <Step.Content>
                            <Step.Title>Billing</Step.Title>
                            <Step.Title>Info</Step.Title>
                        </Step.Content>
                    </Step>

                    <Step active={currentStep === 'confirm'} disabled={currentStep !== 'confirm'}>
                        <Icon name="info" />
                        <Step.Content>
                            <Step.Title>Confirm</Step.Title>
                        </Step.Content>
                    </Step>
                </Step.Group>
            </div>
        </div>
    );
};

// const mapStateToProps = state => ({ user: state.user });

// export default connect(mapStateToProps)(SiteHeader);
export default withAppContext(SiteHeader);
